import { css } from 'react-emotion';
import { flex, flexColumn } from 'appStyles';

export const container = css`
  ${flexColumn};
  align-items: flex-start;
  box-shadow: 6px 7px 5px -2px #c2baba;
  border: 1px solid #c2baba;   
`;

export const titleInput = css`
  width: 40rem;
  background: none;
  color: white;
  font-size: 1.5rem;
  outline: none;
  box-shadow: none;
  border: 1px solid #1F3747;
  padding: 1rem;
  transition: .4s;

  &:hover, &:focus {
    border-color: aqua;
    transition: 1s;
  }
`;

export const textArea = css`
  /* margin-top: 3rem; */
  resize: none;
  width: 40rem;
  min-height: 7rem;
  background: none;
  color: white;
  font-size: 1.5rem;
  outline: none;
  box-shadow: none;
  border: 1px solid #1F3747;
  padding: 1rem;
  transition: .4s;

  &:hover {
    border-color: aqua;
    transition: 1s;
  }
`;


export const inputContainer = css`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1.5em;

  span {
    margin-right: 0.5rem;
  }
`;

export const fontStyle = css`
  ${flex};
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  border: 1px solid #1F3747;

  &:hover {
    background: aqua;
  }
`;

export const flexRow = css`
  display: flex;
  flex-direction: row;
`;

export const textStyleButtonGroup = css`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  width: 13em;
`;
